import { render } from "./ViewDashboard.vue?vue&type=template&id=04c617d8&scoped=true"
import script from "./ViewDashboard.vue?vue&type=script&lang=js"
export * from "./ViewDashboard.vue?vue&type=script&lang=js"

import "./ViewDashboard.vue?vue&type=style&index=0&id=04c617d8&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c617d8"]])

export default __exports__